<template>
  <div class="card">
    <div class="card-header d-flex customStickyCardHeader justify-content-between">
      <h6 class="mb-4" style="align-self: center">
      </h6>
    </div>
    <div class="card-body">
      <textareaVue v-model="text_data" :title="$t('lbl_EMPBE_Reason')"></textareaVue>
      
      <!-- 原因选择 Chips -->
      <p>中文范本</p>
       <div v-if="rejectType=='ads'">
      <div  class="RejectReasonChips cmt-8" v-if="availableReasons.length > 0">
        <button
          v-for="(reason, index) in availableReasons"
          :key="index"
          type="button"
          class="Chip"
          @click="selectReason(reason,'cn')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
            <g>
              <path d="M25.3332 17.3337H17.3332V25.3337H14.6665V17.3337H6.6665V14.667H14.6665V6.66699H17.3332V14.667H25.3332V17.3337Z"></path>
            </g>
          </svg>
          <span>{{ reason.RejectTitle || '' }}</span>
        </button>
      </div>

      <hr/>
      <!-- 原因选择 Chips English-->
       <p>英文范本</p>
      <div class="RejectReasonChips cmt-8" v-if="availableReasonsEN.length > 0">
        <button
          v-for="(reason, index) in availableReasonsEN"
          :key="index"
          type="button"
          class="Chip"
          @click="selectReason(reason,'en')"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
            <g>
              <path d="M25.3332 17.3337H17.3332V25.3337H14.6665V17.3337H6.6665V14.667H14.6665V6.66699H17.3332V14.667H25.3332V17.3337Z"></path>
            </g>
          </svg>
          <span>{{ reason.RejectTitle || '' }}</span>
        </button>
      </div>
      </div>

      <b-button variant="danger" class="f-right" @click="todo">
        {{ $t("lbl_confirm") }}
      </b-button>
    </div>
  </div>
</template>

<script>
import textareaVue from '../../../components/form/textarea.vue';
import { adminService } from '../../../_services';
export default {
  components: {
    textareaVue
  },
  props: {
    rejectType: {
      type: String,
      default: "other"
    }
  },
  data() {
    return {
      text_data: '',
      // 所有可用的驳回原因（存储对象 { RejectTitle, RejectReason }）
      allReasons: [],
      allReasonsEN: [],
      // 已选择的原因（存储完整的 reason 对象）
      selectedReasons: [],
      selectedReasonsEN: [],
      // 加载状态
      loading: false,
      // 是否使用API（设为 false 时使用写死的数据）
      useApi: false
    };
  },
  computed: {
    // 可用的原因（未选择的）
    availableReasons() {
      return this.allReasons.filter(reason => {
        // 通过 RejectTitle 来判断是否已选择
        const title = reason.RejectTitle || '';
        return !this.selectedReasons.some(selected => {
          const selectedTitle = selected.RejectTitle || '';
          return selectedTitle === title;
        });
      });
    },
    availableReasonsEN() {
      return this.allReasonsEN.filter(reason => {
        const title = reason.RejectTitle || '';
        return !this.selectedReasonsEN.some(selected => {
          const selectedTitle = selected.RejectTitle || '';
          return selectedTitle === title;
        });
      });
    }
  },
  watch: {
    // 监听 textarea 内容变化，当用户删除某行时，恢复对应的 chip
    text_data(newVal) {
      this.syncSelectedReasonsFromText();
    }
  },
  mounted() {
    this.loadRejectReasons();
  },
  methods: {
    normalizeReasonText(val) {
      return String(val ?? '')
        .replace(/\r?\n/g, '')
        .trim();
    },
    // 获取写死的默认数据
    getDefaultReasons() {
      return [
        {
          RejectTitle: '广告尺寸错误',
          RejectReason: '广告图尺寸错误，请调整为：[指定尺寸，例如(宽) 480 x (高) 291 像素]，支持 GIF / JPEG / JPG 格式。建议检查预览效果后重新上传，谢谢。'
        },
        {
          RejectTitle: '手机广告尺寸错误',
          RejectReason: '手机广告尺寸错误，请调整手机版：[指定尺寸，例如(宽) 1000 x (高) 375 像素]。支持 GIF / JPEG / JPG 格式，重新上传，谢谢。'
        },
        {
          RejectTitle: '图片模糊',
          RejectReason: '广告图片模糊，上线后可能无法清晰展示，请上传高清版本（不低于72dpi）。建议预览实际效果后重新提交，谢谢。'
        },
        {
          RejectTitle: '缺少或更新LOGO',
          RejectReason: '请到【公司资料】-【网上展台定制】上传贵司高清LOGO，点击保存并提交后，到【广告宣传】重新提交相关广告，谢谢。'
        },
        {
          RejectTitle: '内容过多或不清晰',
          RejectReason: '广告内容过多或文字密集，上线后无法清晰展示。建议精简为图片（产品图/LOGO图）+少量文字（公司名/主营产品/标语），修改后重新提交，谢谢。'
        },
        {
          RejectTitle: '客户需修改内容',
          RejectReason: '客户需修改[指定部分，例如内容、标签或图片]。请根据要求调整后重新提交，谢谢。'
        },
        {
          RejectTitle: '敏感词汇',
          RejectReason: '广告中包含敏感词汇（如"[具体词汇，例如最/全球一流]"），可能违反广告法。请调整描述或提供证明文件后重新上传，谢谢。'
        },
        {
          RejectTitle: '缺少特定资料',
          RejectReason: '请补充上传[指定资料，例如置顶广告/视频广告]的资料。操作：[简要步骤，例如在产品资料中选择并提交]，谢谢。'
        },
        {
          RejectTitle: '移除二维码/电话/网址',
          RejectReason: '为避免流量分散，请移除广告中的直接联系方式（如二维码/电话/网址）。确保引导至网上展台，修改后重新提交，谢谢。'
        }


      ]
    },
    getDefaultReasonsEN() {
      return [
          {
            "RejectTitle": "Ad Size Error",
            "RejectReason": "Ad image size error, please adjust to: [specified size, for example (width) 480 x (height) 291 pixels], supports GIF / JPEG / JPG formats. It is recommended to check the preview effect and re-upload, thank you."
          },
          {
            "RejectTitle": "Mobile Ad Size Error",
            "RejectReason": "Mobile ad size error, please adjust the mobile version: [specified size, for example (width) 1000 x (height) 375 pixels]. Supports GIF / JPEG / JPG formats, re-upload, thank you."
          },
          {
            "RejectTitle": "Image Blurry",
            "RejectReason": "Ad image is blurry, may not display clearly after going online, please upload a high-definition version (not less than 72dpi). It is recommended to preview the actual effect and resubmit, thank you."
          },
          {
            "RejectTitle": "Missing or Update LOGO",
            "RejectReason": "Please go to [Company Information] - [Online Booth Customization] to upload your company's high-definition LOGO, click save and submit, then go to [Advertising Promotion] to resubmit the relevant ads, thank you."
          },
          {
            "RejectTitle": "Too Much Content or Unclear",
            "RejectReason": "Ad content is too much or text-dense, cannot display clearly after going online. Suggest simplifying to image (product image/LOGO image) + a small amount of text (company name/main products/slogan), modify and resubmit, thank you."
          },
          {
            "RejectTitle": "Customer Needs to Modify Content",
            "RejectReason": "Customer needs to modify [specified part, for example content, tags or images]. Please adjust according to requirements and resubmit, thank you."
          },
          {
            "RejectTitle": "Sensitive Words",
            "RejectReason": "Ad contains sensitive words (such as \"[specific words, for example best/world-class]\"), may violate advertising laws. Please adjust the description or provide proof documents and re-upload, thank you."
          },
          {
            "RejectTitle": "Missing Specific Materials",
            "RejectReason": "Please supplement and upload [specified materials, for example top ad/video ad] materials. Operation: [brief steps, for example select and submit in product information], thank you."
          },
          {
            "RejectTitle": "Remove QR Code/Phone/URL",
            "RejectReason": "To avoid traffic dispersion, please remove direct contact methods in the ad (such as QR code/phone/URL). Ensure guidance to the online booth, modify and resubmit, thank you."
          }
        ]
    },
    // 处理并规范化原因数据
    processReasonsData(rawData) {
      if (!Array.isArray(rawData) || rawData.length === 0) {
        return [];
      }

      // 处理数据，保留对象结构，兼容大小写字段名
      const reasons = rawData
        .map(item => {
          if (!item || typeof item !== 'object') return null;
          // 兼容大小写：优先使用大写（RejectTitle/RejectReason），如果没有则使用小写（rejectTitle/rejectReason）
          return {
            RejectTitle: item.RejectTitle || item.rejectTitle || '',
            RejectReason: item.RejectReason || item.rejectReason || ''
          };
        })
        .filter(item => item && (item.RejectTitle || item.RejectReason));

      // 去重（根据 RejectTitle 去重，保持原顺序）
      const seen = new Set();
      return reasons.filter(r => {
        const title = r.RejectTitle || '';
        if (seen.has(title)) {
          return false;
        }
        seen.add(title);
        return true;
      });
    },
    // 从API加载驳回原因列表
    async loadRejectReasonsFromApi() {
      try {
        const res = await adminService.GetRejectReasons();
        if (res.isSuccessful && res.data) {
          // 兼容多种返回格式，期望：[{ RejectReason: '...', RejectTitle: '...' }, ...]
          const raw =
            Array.isArray(res.data)
              ? res.data
              : Array.isArray(res.data.reasons)
                ? res.data.reasons
                : Array.isArray(res.data.rejectReasons)
                  ? res.data.rejectReasons
                  : [];

          return this.processReasonsData(raw);
        }
        return [];
      } catch (error) {
        console.error('加载驳回原因失败:', error);
        return [];
      }
    },
    // 加载驳回原因列表（主方法）
    async loadRejectReasons() {
      this.loading = true;
      try {
        if (this.useApi) {
          // 从API加载
          this.allReasons = await this.loadRejectReasonsFromApi();
        } else {
          // 使用写死的数据
          this.allReasons = this.getDefaultReasons();
          this.allReasonsEN = this.getDefaultReasonsEN();
        }
      } finally {
        this.loading = false;
      }
    },
    todo() {
      
      this.$emit('todo', this.text_data);
      /* Clear Template content and selected reasons*/
      this.selectedReasons = [];
      this.selectedReasonsEN = [];
    },
    // 同步已选择的原因列表（根据 textarea 内容）
    syncSelectedReasonsFromText() {
      if (!this.text_data) {
        // 如果 textarea 为空，清空已选择列表
        this.selectedReasons = [];
        return;
      }
      
      // 将 textarea 内容按换行符分割，并规范化处理
      const lines = this.text_data.split(/\r?\n/)
        .map(line => this.normalizeReasonText(line))
        .filter(Boolean); // 过滤空行
      
      // 更新已选择列表：只保留还在 textarea 中的原因（通过 RejectReason 匹配）
      this.selectedReasons = this.selectedReasons.filter(reason => {
        const reasonText = this.normalizeReasonText(reason.RejectReason || '');
        return lines.includes(reasonText);
      });
    },
    // 选择原因
    selectReason(reason,lang) {
      // reason 是对象 { RejectTitle, RejectReason }
      const reasonText = this.normalizeReasonText(reason.RejectReason || '');
      if (!reasonText) return;
      var selectedReasons= this.selectedReasons;
      if(lang == 'en') {
        selectedReasons= this.selectedReasonsEN;
      }

      
      // 检查是否已选择（通过 RejectTitle 判断）
      const title = reason.RejectTitle || '';
      const isAlreadySelected = selectedReasons.some(selected => {
        const selectedTitle = selected.RejectTitle || '';
        return selectedTitle === title;
      });
      
      if (!isAlreadySelected) {
        // 添加到已选择列表
        selectedReasons.push(reason);
        
        // 更新文本内容：添加 RejectReason，换行显示
        if (this.text_data) {
          this.text_data += '\n' + reasonText;
        } else {
          this.text_data = reasonText;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.RejectReasonChips {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  margin-bottom: 16px;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .Chip {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    padding: 6px 12px;
    background-color: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 14px;
    color: #333;
    min-height: 32px;
    
    &:hover {
      background-color: #f5f5f5;
      border-color: #d0d0d0;
    }
    
    &:active {
      transform: scale(0.98);
    }
    
    svg {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }
    
    span {
      overflow: visible;
      white-space: normal;
      word-wrap: break-word;
      word-break: break-word;
      flex: 1;
      text-align: left;
    }
  }
}
</style>
